import React from 'react'
import { connect } from 'react-redux'
import { Flex, Box } from 'reflexbox'
import * as BP from '@blueprintjs/core'
import {
    getAllHistoryLogsFromServer,
    getHistoryLogs,
} from 'src/store/modules/runbooks'

class HistoryLogs extends React.Component {
    componentDidMount() {
        this.props.getAllHistoryLogsFromServer(
            this.props.session,
            this.props.logType
        )
    }

    componentDidUpdate(prevProps) {
        if (this.props.logType !== prevProps.logType) {
            this.props.getAllHistoryLogsFromServer(
                this.props.session,
                this.props.logType
            )
        }
    }
    render() {
        if (!this.props.historyLogs) return null
        return (
            <Flex wrap w={1}>
                {this.props.historyLogs.map((log) => (
                    <Box w={1} key={log.id}>
                        <BP.Card
                            interactive
                            elevation={BP.Elevation.TWO}
                            style={{ padding: 8, margin: 2 }}
                        >
                            <BP.Tag style={{ marginRight: 10 }}>
                                {log.uid}
                            </BP.Tag>
                            <BP.Tag
                                style={{ marginLeft: 5, marginRight: 10 }}
                                intent="danger"
                            >
                                <BP.Tooltip
                                    disabled={!log.action.description}
                                    content={
                                        <div>{log.action.description}</div>
                                    }
                                >
                                    {log.action.name}
                                </BP.Tooltip>
                            </BP.Tag>
                            <BP.Tag style={{ marginRight: 10 }}>
                                {log.createdBy?.email ?? 'System'}
                            </BP.Tag>
                            {log.message}
                            <span style={{ float: 'right', color: 'grey' }}>
                                {log.createdAt}
                            </span>
                        </BP.Card>
                    </Box>
                ))}
            </Flex>
        )
    }
}

export default connect(
    (state) => ({
        historyLogs: getHistoryLogs(state),
    }),
    {
        getAllHistoryLogsFromServer,
    }
)(HistoryLogs)
